import { render, staticRenderFns } from "./userReset.vue?vue&type=template&id=820da8b8"
import script from "./userReset.vue?vue&type=script&lang=js"
export * from "./userReset.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userReset.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/login/userReset.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports